import React from "react";
import {useNavigate, useLocation} from "react-router-dom";
import DashboardCards from "../../../components/DashboardCard/DashboardCards";
import Pagination from "../../../components/Table/components/Pagination";
import {useGetSnapshots} from "./useSnapshotsData";
import "./snapshot.scss";

function Snapshot() {
  const {loadSnapshots, paginationConfig, snapshotsList, snapshotTotalCount} =
    useGetSnapshots();
  const location = useLocation();
  const navigate = useNavigate();
  const url = location.pathname;

  const handleClick = (dashboard) => {
    navigate(`${url}/snapshots/${dashboard.id}/`, {
      state: {isEditable: true},
    });
  };

  return (
    <div className="snapshot-container">
      <DashboardCards
        dashboards={snapshotsList}
        updateCallback={loadSnapshots}
        columnWidth={4}
        type="Snapshot"
        onCardClick={handleClick}
        isEditable={true}
      />
      {snapshotTotalCount && snapshotTotalCount > 25 ? (
        <Pagination
          currentPage={paginationConfig.currentPage}
          onPageChange={paginationConfig.onPageChange}
          totalCount={snapshotTotalCount}
        />
      ) : null}
    </div>
  );
}

Snapshot.propTypes = {};

export default Snapshot;
